'use client';
import { Select as Select$1 } from './select.mjs';
import { SelectClearTrigger } from './select-clear-trigger.mjs';
import { SelectContent } from './select-content.mjs';
export { useSelectContext } from './select-context.mjs';
import { SelectControl } from './select-control.mjs';
import { SelectIndicator } from './select-indicator.mjs';
import { SelectItem } from './select-item.mjs';
export { useSelectItemContext } from './select-item-context.mjs';
import { SelectItemGroup } from './select-item-group.mjs';
import { SelectItemGroupLabel } from './select-item-group-label.mjs';
import { SelectItemIndicator } from './select-item-indicator.mjs';
import { SelectItemText } from './select-item-text.mjs';
import { SelectLabel } from './select-label.mjs';
import { SelectPositioner } from './select-positioner.mjs';
import { SelectTrigger } from './select-trigger.mjs';
import { SelectValueText } from './select-value-text.mjs';

const Select = Object.assign(Select$1, {
  Root: Select$1,
  ClearTrigger: SelectClearTrigger,
  Content: SelectContent,
  Control: SelectControl,
  Indicator: SelectIndicator,
  Item: SelectItem,
  ItemGroup: SelectItemGroup,
  ItemGroupLabel: SelectItemGroupLabel,
  ItemIndicator: SelectItemIndicator,
  ItemText: SelectItemText,
  Label: SelectLabel,
  Positioner: SelectPositioner,
  Trigger: SelectTrigger,
  ValueText: SelectValueText
});

export { Select, SelectClearTrigger, SelectContent, SelectControl, SelectIndicator, SelectItem, SelectItemGroup, SelectItemGroupLabel, SelectItemIndicator, SelectItemText, SelectLabel, SelectPositioner, SelectTrigger, SelectValueText };
